module.exports = __webpack_public_path__ + "static/img/wdtybox_1.c61ebef.png";


//////////////////
// WEBPACK FOOTER
// ./src/common/images/productCenter/B2/wdtybox_1.png
// module id = kRdf
// module chunks = 0